import type { RealtimeMessage } from "@zplanem/responses"

type TicketRealtimeInvalidationScope =
	| { kind: "ticket"; propertyId: string; ticketId: string }
	| { kind: "access_lost"; ticketId: string }

export function ticketRealtimeInvalidationScope(
	msg: RealtimeMessage,
): TicketRealtimeInvalidationScope | null {
	switch (msg.event) {
		case "ticket.created":
		case "ticket.assigned":
		case "ticket.updated":
		case "ticket.status_changed":
		case "ticket.deleted":
		case "ticket.comment.added":
		case "ticket.comment.deleted":
		case "ticket.comment.updated":
		case "ticket.comment.mention":
		case "ticket.mentioned":
			return {
				kind: "ticket",
				propertyId: msg.payload.propertyId,
				ticketId: msg.payload.ticketId,
			}
		case "ticket.access_lost":
			return { kind: "access_lost", ticketId: msg.payload.ticketId }
		default:
			return null
	}
}
